export default __webpack_public_path__ + "static/media/qr_chplay_yokara.5798357f.svg";